import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { StateService } from '@uirouter/angular';
import { WikiService } from '../../../widgets/wiki/services/wiki.service';
import { WikiBrowseService } from '../services/wiki.browse.service';
import { BreadcrumbService } from '../../../widgets/breadcrumbs/breadcrumbs.service';
import { FilterService } from '../../../core/services/core.filter.service';
import { GfTranslateService } from '../../../core/services/core.translate.service';
import { GfTitleService } from '../../../core/services/core.title.service';
import { ReportsDataService } from '../../../core/services/core.report-data.service';
import { WikiDeleteModalComponent } from '../../../widgets/wiki/wiki-delete-modal/wiki.delete.modal.component';

import * as $ from 'jquery';
import * as _ from 'lodash';
import { marker } from '../../../core/services/ngx-translate-extract-marker';

@Component({
    selector: 'wiki-browse',
    template: require('./wiki.browse.component.html')
})
export class WikiBrowseComponent implements OnInit {

    @Input() project: any = null;

    protected wikiItems: any = null;
    protected canAdminWiki: boolean = false;

    private baseFilters: any = {};
    protected filters: any = {};
    private anyFiltersSet: boolean = false;

    protected sortFields: any = {};
    private sort: any = {};
    private paging: any = {};

    constructor(
        private $window: Window,
        public $state: StateService,
        private wikiService: WikiService,
        private wikiBrowseService: WikiBrowseService,
        private breadcrumbService: BreadcrumbService,
        private filterService: FilterService,
        private gfTranslateService: GfTranslateService,
        private modalService: NgbModal,
        private titleService: GfTitleService,
        private reportsDataService: ReportsDataService,
    ) { }

    ngOnInit() {
        this.titleService.setTitle(this.project.name, 'Wiki', 'Browse');
        this.wikiService.wikiPage$.next(null);

        this.sortFields = this.wikiBrowseService.getSortFields();
        this.sort = this.filterService.getSortValues('pagename', 'asc');
        this.paging = this.filterService.getPagingValues();

        this.baseFilters = this.wikiBrowseService.getBaseFilters();
        this.setFilterValues();
        this.loadAuthorFilter();

        this.breadcrumbService.setCrumbs([
            this.breadcrumbService.projectCrumb(this.project),
            this.breadcrumbService.translatedCrumb(marker('Wiki'), 'home.project.summary.wiki', { pagename: 'FrontPage' }),
            this.breadcrumbService.translatedCrumb(marker('Browse'), '.', {})
        ]);

        this.checkWikiPermissions();
        this.getWikiItems();
    };

    checkWikiPermissions() {
        let projectAdmin = _.get(this.project, 'rel.permissions.admin', false);
        let wikiAdmin = (_.get(this.project, 'rel.permissions.wiki', 0) >= 99);
        this.canAdminWiki = projectAdmin || wikiAdmin;
    }

    // Author options are project members, which load after the initial render.
    loadAuthorFilter() {
        return this.reportsDataService.getProjectMembers().then((members: any[]) => {
            this.baseFilters = this.wikiBrowseService.getBaseFilters(members);
            this.setFilterValues();
        });
    }

    setFilterValues() {
        var mainFields = this.filterService.setFilterValues(_.cloneDeep(this.baseFilters));

        // Older bookmarks pass the author as a unixName rather than a user id.
        var author = _.find(mainFields, { alias: 'author' });
        if (author && !_.isObject(author.value)) {
            author.value = _.find(author.fieldElements, (e) => e.id !== '' && e.unixName == author.value)
                || _.head(author.fieldElements);
        }

        this.filters = { main_fields: mainFields };

        this.anyFiltersSet = this.filterService.anyFiltersSet(_.cloneDeep(this.baseFilters));
    }

    getWikiItems = () => {
        this.wikiItems = false;

        // WikiService::getWiki() reads `project`; the ancestor state's path param is `unixName`.
        var fetchArgs = this.filterService.getFetchArgs({ project: this.$state.params.unixName });

        this.wikiService.fetch(fetchArgs)
        .then((response: any) => {
            this.wikiItems = response.items;
        }, (err) => {
            console.log(err);
            this.wikiItems = [];
        });
    };

    toggleFilterPanel = (item) => {
        ($('#' + item) as any).collapse('toggle');
    };

    applyFilters = (overrides: any = {}) => {
        var newParams = _.pickBy(Object.assign(
            { unixName: this.$state.params.unixName },
            this.sort,
            this.paging,
            this.filterService.getFilterValues(_.get(this.filters, 'main_fields', [])),
            overrides
        ), function (value) {
            return (undefined != value && null != value && value != '');
        });

        this.$state.go('.', newParams, { inherit: false }).then(() => {
            this.setFilterValues();
            this.getWikiItems();
        });
    };

    onApplyFilters = () => {
        this.paging.page_num = 1;
        this.applyFilters();
    };

    onResetFilters = () => {
        this.paging.page_num = 1;
        this.filters = { main_fields: this.baseFilters };
        this.applyFilters();
    };

    setSort = (sort) => {
        this.sort = { sort_field: sort.key, sort_dir: sort.sortDir };
        this.applyFilters();
    };

    onPage = (paging) => {
        _.assignIn(this.paging, paging);
        this.applyFilters();
    };

    deleteWikiPage = (wikiPage) => {
        const modalRef = this.modalService.open(WikiDeleteModalComponent);
        modalRef.componentInstance.wiki = wikiPage;

        modalRef.componentInstance.onDelete = () => {
            this.getWikiItems();
        };

        modalRef.componentInstance.onClose = () => {
            modalRef.close();
        };
    }
}